"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var replacePlaceholders_1 = require("../utils/replacePlaceholders");
var TranslationHelper = /** @class */ (function () {
    function TranslationHelper(targetTranslations, fallbackTranslations) {
        this.targetTranslations = {};
        this.fallbackTranslations = {};
        this.targetTranslations = targetTranslations;
        this.fallbackTranslations = fallbackTranslations;
        this.translate = this.translate.bind(this);
    }
    TranslationHelper.prototype.translate = function (key, placeholders) {
        var translation = this.getTranslation(key);
        return placeholders
            ? replacePlaceholders_1.replacePlaceholders({ values: placeholders, text: translation })
            : translation;
    };
    TranslationHelper.prototype.getTranslation = function (key) {
        return this.targetTranslations[key] || this.fallbackTranslations[key] || key;
    };
    return TranslationHelper;
}());
exports.TranslationHelper = TranslationHelper;
//# sourceMappingURL=TranslationHelper.js.map